import React from 'react';
import { ToothPeriodontalItem } from '../../../../graphql/graphql';
// @ts-ignore
import styles from './DENTModalOverviewGeneralPeriodontalItemIssues.module.scss';
import { ToothPeriodontalIssues } from '../../Interfaces/ToothPeriodontalIssue.interface';

interface Props {
	issues: ToothPeriodontalIssues;
}

const DENTModalOverviewGeneralPeriodontalItemIssues = ({ issues }: Props) => {
	const { pus, bleeding, plaque, tartar } = issues;

	return (
		<ul className={styles.wrapper}>
			{pus && <li className={styles.pus}></li>}
			{bleeding && <li className={styles.bleeding}></li>}
			{plaque && <li className={styles.plaque}></li>}
			{tartar && <li className={styles.tartar}></li>}
		</ul>
	);
};

export default DENTModalOverviewGeneralPeriodontalItemIssues;
